import React, { useEffect, useState, useContext } from "react";
import { Trans, useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";
import Search from "../../components/Search/Search";
import { useSearchMount } from "../../hooks/useSearchMount";
import ViewCatalogueSwitchBar from "../../components/ViewCatalogueSwitchBar/ViewCatalogueSwitchBar";
import { GlobalContext } from "../../App";
import MountCategories from "../../components/MountCategories/MountCategories";
import MountListView from "../../components/MountListView/MountListView";
import { getCategoryData } from "../Catalogue/Catalogue";
import Loader from "../../components/Loader/Loader";

interface Props {}

const Home: React.FC<Props> = () => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const ctx = useContext(GlobalContext);
  const [mountQuery, setMountQuery] = useState({
    kg: "",
    rpm: "",
    noOfMount: "",
  });

  const { data, isLoading } = useSearchMount(
    mountQuery.rpm,
    mountQuery.kg,
    mountQuery.noOfMount,
    ctx.failSafe
  );
  useEffect(() => {
    const rpm = ctx.rpm ? ctx.rpm : searchParams.get("rpm") || "";
    const kg = ctx.kg ? ctx.kg : searchParams.get("kg") || "";
    const noOfMount = ctx.noOfMount
      ? ctx.noOfMount
      : searchParams.get("noOfMount") || "";
    setMountQuery({ rpm, kg, noOfMount });
  }, [searchParams]);

  const updatorFunction = (obj: any) => {
    ctx.updateGlobalCtx({
      ...ctx,
      ...obj,
    });
  };
  const isValidData = () => {
    const { rpm, noOfMount, kg } = mountQuery;
    if (!Number(rpm)) {
      return false;
    }
    if (!Number(noOfMount)) {
      return false;
    }
    if (!Number(kg)) {
      return false;
    }
    if (Number(rpm) && Number(rpm) <= 99) {
      return false;
    }
    return true;
  };
  const updateFunction = (data: any) => {
    setTimeout(() => {
      if (window.location.hash.length < 3) {
        setMountQuery(data);
        ctx.updateGlobalCtx({
          ...ctx,
          currentView: "GRID",
          currentCategory: "",
        });
      }
    }, 0);
  };

  return (
    <section className="container px-3 py-3  md:px-4 md:py-3 lg:px-5 lg:py-3">
      <section className="pb-3">
        <p className="font-primary">{t("SEARCH_WARN")}</p>
        <Search
          setMountQuery={setMountQuery}
          updatorFunction={updateFunction}
        />
        <small className="block mt-2 text-sm font-primary">{t("NOTE")}</small>
      </section>
      {isLoading ? (
        <section className="pt-6">
          <Loader />
        </section>
      ) : (
        ""
      )}
      {data ? (
        <section className="pt-4">
          <ViewCatalogueSwitchBar
            currentCategory={ctx.currentCategory}
            value={ctx.failSafe}
            view={ctx.currentView}
            updateData={updatorFunction}
            docCenter={true}
            mountDetail={{
              failSafe: ctx.failSafe,
              rpm: mountQuery.rpm,
              noOfMount: mountQuery.noOfMount,
              kg: mountQuery.kg,
            }}
          />
          {isLoading ? (
            <Loader />
          ) : (
            <>
              {ctx.currentView === "GRID" && isValidData() && (
                <MountCategories
                  categoryDatas={data}
                  updateData={updatorFunction}
                  mountDetail={{
                    failSafe: ctx.failSafe,
                    rpm: mountQuery.rpm,
                    noOfMount: mountQuery.noOfMount,
                    kg: mountQuery.kg,
                  }}
                />
              )}
              {ctx.currentView === "LIST" && (
                <MountListView
                  values={getCategoryData(ctx.currentCategory, data)}
                  columns={[
                    { label: "MOUNT_NAME", value: "mountName", sortable: true },
                    { label: "PART_NO", value: "partNumber", sortable: true },
                    { label: "ISO_PER", value: "isolation", sortable: true },
                    {
                      label: "NATURAL_FREQ_HZ",
                      value: "naturalFrequency",
                      sortable: true,
                    },
                    { label: "DEF_MM", value: "deflection", sortable: true },
                    {
                      label: "HARDNESS_WITH_UNIT",
                      value: "hardnessValue",
                      sortable: true,
                    },
                    { label: "DRAW_NO", value: "drawingNum", sortable: true },
                  ]}
                  currentCategory={ctx.currentCategory}
                  failSafe={ctx.failSafe}
                  kg={mountQuery.kg}
                  rpm={mountQuery.rpm}
                  noOfMount={mountQuery.noOfMount}
                />
              )}
              {Array.isArray(data) &&
              ctx.currentView === "GRID" &&
              data.length === 0 &&
              isValidData() ? (
                <section className="my-4 flex justify-content-center">
                  <p className="not-found-border md:w-8 lg:w-9">
                    <p>{t("MOUNT_NOT_FOUND")}</p>
                    <p className="text-sm pt-3">
                      <Trans
                        i18nKey={"CONTACT_FURTHER"}
                        components={[
                          <a
                            className="link"
                            href={`mailto:TIAVS.Design.Enquiries@trelleborg.com`}
                            target={"_blank"}
                          ></a>,
                        ]}
                      ></Trans>
                    </p>
                  </p>
                </section>
              ) : (
                ""
              )}
            </>
          )}
        </section>
      ) : (
        ""
      )}
    </section>
  );
};

export default Home;
